import React from "react";
import Code from "./Code";

import api from "~/services/api";
import definitions from "~/config";
import { getCurrentDomain } from "~/utils";

import "./Email.scss";
import ButtonSecondary from "../Button/ButtonSecondary";
import ButtonPrimary from "../Button/ButtonPrimary";

export default function Email({ fetchMe, onHide }) {
  const [email, setEmail] = React.useState("");
  const [code, setCode] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);

  function handleEmailChange(event) {
    setEmail(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);

    const domain = getCurrentDomain();

    api
      .post(`/v1/request-code`, {
        method: "email_code",
        email,
        appcode: definitions.appcode,
        domain,
      })
      .then(() => {
        setCode(true);
      })
      .catch(() => {
        setError(`Ocorreu um error ao tentar enviar o código de verificação!`);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <React.Fragment>
      {code ? (
        <Code email={email} fetchMe={fetchMe} onHide={onHide} />
      ) : (
        <div className="login-email">
          <div className="text">
            <h1>Acessar com e-mail</h1>
            <p>Insira seu e-mail para efetuar login</p>
            {error && <span>{error}</span>}
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                name="email"
                type="email"
                onChange={handleEmailChange}
                value={email}
                autoFocus
                required
              />
            </div>

            <div className="actions">
              <ButtonSecondary type="button" onClick={onHide}>
                Voltar
              </ButtonSecondary>
              <ButtonPrimary disabled={submitting}>
                {submitting ? "Aguarde..." : "Próximo"}
              </ButtonPrimary>
            </div>
          </form>
        </div>
      )}
    </React.Fragment>
  );
}
